<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="DataOverview")
    h1.title Reinigungsfirmen
    .sub-headline Hier sehen Sie alle Reinigungsfirmen.
    
    .button-wrapper.margin-top      
      b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'DataCleanerNew'})") Neue Reinigungsfirma anlegen

    .card.margin-top
      .main
        b-table(:data="cleaners"
                default-sort-direction="asc"
                default-sort="company"
                hoverable)
          b-table-column(field='company' label='Firma' sortable, v-slot="props")
            | {{props.row.company}}
          b-table-column(field='firstName' label='Vorname' sortable, v-slot="props")
            | {{props.row.firstName}}
          b-table-column(field='lastName' label='Nachname' sortable, v-slot="props")
            | {{props.row.lastName}}
          b-table-column(field='address.street' label='Straße' sortable, v-slot="props")
            | {{props.row.address.street}}
          b-table-column(field='address.zip' label='PLZ' sortable, v-slot="props")
            | {{props.row.address.zip}}
          b-table-column(field='address.city' label='Stadt' sortable, v-slot="props")
            | {{props.row.address.city}}
          b-table-column(label='Aktionen', v-slot="props")
            .button-wrapper
              b-button(type="is-primary" @click="$router.push({ name: 'DataCleanerEdit', params: { id: props.row.id } })") Bearbeiten
              b-button(type="is-danger" @click="deleteCleaner(props.row)") Löschen
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    cleaners() {
      return this.$store.state.cleaners.all;
    },
  },
  methods: {
    deleteCleaner(row) {
      this.$buefy.dialog.confirm({
        title: "Reinigungsfirma löschen",
        message: `Sind Sie sicher, dass Sie die Reinigungsfirma <b>${row.company}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Reinigungsfirma löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("cleaners/delete", { id: row.id });
            this.$buefy.toast.open("Reinigungsfirma gelöscht!");
          } catch (e) {
            this.$store.dispatch(
              "common/showError",
              "Reinigungsfirma konnte nicht gelöscht werden."
            );
          }
        }
      });
    }
  },
  mounted() {
    this.$store.dispatch("cleaners/findAll");
  }
};
</script>

<style lang="scss" scoped>
.icon-name {
  margin-left: $sm-space;
}
</style>